import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonClassNames } from '../../../../models/Common';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { ModalContent } from '../../../../store/reducers/ModalSlice';
import { AnimatedIcon } from '../../AnimatedIcon';
import SuccessIconLight from '../../../../assets/images/lottieIcons/success/success.light.json';
import SuccessIconDark from '../../../../assets/images/lottieIcons/success/success.dark.json';

interface SuccessModalProps {
  handleClose: () => void;
  modalContent: ModalContent | null;
}

export const SuccessModal: FC<SuccessModalProps> = ({ modalContent, handleClose }) => {
  const { t } = useTranslation();
  return (
    <div className="success modals">
      <div className="success__icon-container">
        <AnimatedIcon lightIcon={SuccessIconLight} darkIcon={SuccessIconDark} className="icon-success" />
      </div>
      <div className="modals__header">
        <article className="modals__header__title">{modalContent?.title}</article>
        <p className="modals__header__description">
          {modalContent?.description} <strong>{modalContent?.boldDescription}</strong>
        </p>
      </div>
      <div className="success__btn-group">
        <CustomMUIButton
          label={t('buttons.close')}
          handleClick={handleClose}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
        />
      </div>
    </div>
  );
};
